import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { garnerConfig } from "./data";

export default function GarnerPage() {
  return <CityPageTemplate config={garnerConfig} />;
}